import { render } from "./SearchField.vue?vue&type=template&id=5b9eb590"
import script from "./SearchField.vue?vue&type=script&lang=ts"
export * from "./SearchField.vue?vue&type=script&lang=ts"
script.render = render

export default script